
import { createClient } from '@supabase/supabase-js'
//https://xgqcuxqacpepteqmkali.supabase.co
const supabaseUrl = "https://xgqcuxqacpepteqmkali.supabase.co"//"https://blvbiqvnxoiewpjkpnfz.supabase.co"//"https://ctljbqqsftgnrwxlskbd.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhncWN1eHFhY3BlcHRlcW1rYWxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE4NTY5MzUsImV4cCI6MjA4NzQzMjkzNX0.DpSM4pYDzleWpJxHJH0H2L1Jp4bmTso_9Gro3jZ6RCc"
const supabaseClient = createClient(supabaseUrl, supabaseAnonKey,{auth:{autoRefreshToken:false,}})

export  {
  supabaseClient,
}